import { createSliceForList } from "../helpers";

export const issueSlice = createSliceForList({
  name: "issue",
  reducers: {
    issueListFetched: (state, action) => {
      const { total, records } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.records = records;
      state.total = total;
    },
    issueDetailFetched: (state, action) => {
      const result = action.payload;
      state.result = result;
      state.error = null;
      state.isLoading = false;
    },
  },
});
